import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

function positiveCount(value: number): number {
  if (!Number.isSafeInteger(value) || value < 1) {
    throw new RangeError('Skeleton row and column counts must be positive integers.');
  }
  return value;
}

@Component({
  selector: 'app-skeleton',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (layout() === 'table') {
      @for (row of rowIndexes(); track row) {
        <div class="skeleton-row">
          @for (column of columnIndexes(); track column) {
            <span class="skeleton-shape skeleton-cell"></span>
          }
        </div>
      }
    } @else {
      <span class="skeleton-shape skeleton-block"></span>
    }
  `,
  styleUrl: './skeleton.component.scss',
  host: {
    'aria-hidden': 'true',
    '[style.width]': 'width()',
    '[style.height]': 'layout() === "table" ? "auto" : height()',
    '[style.--skeleton-radius]': 'borderRadius()',
    '[style.--skeleton-columns]': 'columns()'
  }
})
export class SkeletonComponent {
  readonly layout = input<'block' | 'table'>('block');
  readonly rows = input(5, { transform: positiveCount });
  readonly columns = input(4, { transform: positiveCount });
  readonly width = input('100%');
  readonly height = input('16px');
  readonly borderRadius = input('4px');
  protected readonly rowIndexes = computed(() => Array.from({ length: this.rows() }, (_, index) => index));
  protected readonly columnIndexes = computed(() => Array.from({ length: this.columns() }, (_, index) => index));
}